const SET_PARTNER_LINKS = "AFTERMARKET_PARTNER_SET_PARTNER_LINKS";
const SET_IS_NED_ACCOUNT = "AFTERMARKET_SET_IS_NED_ACCOUNT";
const SET_INTEGRATION_SETTINGS = "AFTERMARKET_SET_INTEGRATION_SETTINGS";
const CLEAR = "MENU_CONSTRUCTOR_CLEAR";

export { SET_PARTNER_LINKS, SET_INTEGRATION_SETTINGS, SET_IS_NED_ACCOUNT, CLEAR };
